import { useEffect, useState } from "react";
import "./Bridge.css";
import SEO from "components/Common/SEO";
import { getPageTitle } from "lib/legacy";
import { useWeb3React } from "@web3-react/core";
import { Trans, t } from "@lingui/macro";
import SwitchOver from "img/SwitchOver.png";
import MarkIcon from "img/Mark.png";
import metaMaskIcon from "img/ic_metamask.png";
import ethIcon from "img/ic_eth_24.svg";
import optimismIcon from "img/ic_optimism.svg";
import Arrow from "img/arrow.png";
import IncreaseIcon from "img/Increase.png";
import CopyIcon from "img/Copy.png";
import DownloadIcon from "img/Download.png";
import ActiveIcon from "img/correct.png";
import LoadingIcon from "img/loading.svg";
import cx from "classnames";
import Footer from "components/Footer/Footer";
import Modal from "components/Modal/Modal";
import { importImage } from "lib/legacy";
import { getInjectedHandler } from "lib/wallets";
import { useCopyToClipboard, createBreakpoint } from "react-use";
// import SelectDropadown from "../SelectDropadown/SelectDropadown";
import SelectDropdown from "components/SelectDropdown/SelectDropdown";
import TooltipIcon from "components/Tooltip/TooltipIcon";
import { bigNumberify, formatAmount, expandDecimals } from "lib/numbers";
import { switchNetwork } from "lib/wallets";
import { helperToast } from "lib/helperToast";
import {
  getBridgeToken,
  getConfigChainsIdByName,
  getBalance,
  getTokenBalance,
  getConfigCSAByName,
  getTokenApprove,
  sendApprove,
  sendAnySwapOutNative,
  senAnySwapOutUnderlying,
  getSwapTx,
  getConfigChainNamedById,
  configScanPath
} from "components/Bridge/bridge";
import { useLocalStorageSerializeKey } from "lib/localStorage";
import { deserializeSampleStats } from "components/Referrals/referralsHelper";
// import { setVerbosity } from "ts-invariant";
const decimals = Math.pow(10, 8);
const bigDec = bigNumberify(decimals);


function Bridge ({ connectWallet }) {

  const { active, account, library, chainId } = useWeb3React();

  const [isVisible, setIsVisible] = useState(false);
  const isMax = true
  const isMin = true
  const [fromToken, setFromToken] = useState('Ethereum')
  const [toToken, setToToken] = useState('Optimism')

  const [formData, setFormData] = useState(['Ethereum'])
  const [toData, setToData] = useState(['Optimism'])
  const [tokenData, setTokenData] = useState([
    {
      symbol: 'ETH',
      balance: bigNumberify(0),
      decimals: 18
    },
    {
      symbol: 'BTC',
      balance: bigNumberify(0),
      decimals: 8
    }
  ]
  )
  const [toTokenData, setToTokenData] = useState([
    {
      symbol: 'ETH',
      balance: bigNumberify(0),
      decimals: 18
    },
    {
      symbol: 'BTC',
      balance: bigNumberify(0),
      decimals: 8
    }
  ])
  const [, copyToClipboard] = useCopyToClipboard();
  const [currenToken, setCurrenToken] = useState({
      symbol: 'ETH',
      balance: bigNumberify(0),
      decimals: 18
  })
  const [isApprove, setIsApprove] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isSendTx, setIsSendTx] = useState(false);
  const [swapTx, setSwapTx] = useState({
    formatswapvalue: "0",
    formatvalue: "0",
    from: "-",
    fromChainID: "1",
    pairid: "-",
    status: 0,
    swaptx: "-",
    time: "",
    formatswapvalue: "0",
    timestamp: 0,
    toChainID: "10",
    txid: "-",
    toToken: "-"
  });
  const [fromValue, setFromValue] = useState(0);
  const [toValue, setToValue] = useState(0);
  const [fromChainAmount, setFromChainAmount] = useState(bigNumberify(0));
  const [toChainAmount, setToChainAmount] = useState(bigNumberify(0));
  const [fromApproveAmount, setFromApproveAmount] = useState(bigNumberify(0));
  const [toApproveAmount, setToApproveAmount] = useState(bigNumberify(0));
  const [TokenModalVisible, setTokenModalVisible] = useState(false);
  const [TradeModalVisible, setTradeModalVisible] = useState(false);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);
  const open = () => setIsEditModalOpen(true);
  const close = () => setIsEditModalOpen(false);
  const toImage = importImage(`ic_${toToken.toLowerCase()}_40.png`);
  const fromImage = importImage(`ic_${fromToken.toLowerCase()}_40.png`);
  const fromChainId = getConfigChainsIdByName(fromToken);
  const toChainId = getConfigChainsIdByName(toToken);

  const [sent, setsent] = useState(false)
  const [Confirmed, setConfirmed] = useState(false)
  const [Routing, setRouting] = useState(false)
  const [Success, setSuccess] = useState(false)
  const [searchKeyword, setSearchKeyword] = useState("");
  const [bridgeSwapTx, setBridgeSwapTx] = useLocalStorageSerializeKey([chainId, currenToken.symbol, "BRIDGE", account], [], {
    deserializer: deserializeSampleStats,
  });
  const multiChainConfigs = {
    1: {
      ETH: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
      BTC: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",

    },
    10: {
      ETH: "0x4200000000000000000000000000000000000006",
      BTC: "0x68f180fcce6836688e9084f035309e29bf0a2095",
    }
  };
  const [toBridgeData, setToBridgeData] = useState({
    BTC: {
      BigValueThreshold: "0",
      DepositAddress: "",
      MaximumSwap: "0",
      MaximumSwapFee: "0",
      MinimumSwap: "0",
      MinimumSwapFee: "0",
      SwapFeeRatePerMillion: 0.01,
      decimals: 8,
      prices: 0,
      address: `${multiChainConfigs[toChainId]["BTC"]}`
    },
    ETH: {
      BigValueThreshold: "0",
      DepositAddress: "",
      MaximumSwap: "0",
      MaximumSwapFee: "0",
      MinimumSwap: "0",
      MinimumSwapFee: "0",
      SwapFeeRatePerMillion: 0.01,
      decimals: 18,
      prices: 0,
      address: `${multiChainConfigs[toChainId]["ETH"]}`
    },
})
const [fromBridgeData, setFromBridgeData] = useState( {
  BTC: {
      BigValueThreshold: "0",
      DepositAddress: "",
      MaximumSwap: "0",
      MaximumSwapFee: "0",
      MinimumSwap: "0",
      MinimumSwapFee: "0",
      SwapFeeRatePerMillion:0.01,
      decimals: 8,
      prices:0,
      address:`${multiChainConfigs[toChainId]["BTC"]}`
  },
  ETH:   {
      BigValueThreshold: "0",
      DepositAddress: "",
      MaximumSwap: "0",
      MaximumSwapFee: "0",
      MinimumSwap: "0",
      MinimumSwapFee: "0",
      SwapFeeRatePerMillion:0.01,
      decimals: 18 ,
      prices:0,
      address:`${multiChainConfigs[toChainId]["ETH"]}`
  },
})
  useEffect(() => {
    const value = window.localStorage.getItem(JSON.stringify([chainId, currenToken.symbol, "BRIDGE", account]))
    if (value || value != null) {
      const arrValue = JSON.parse(value);
      if (arrValue && arrValue.length > 0) {
        getSwapTx(arrValue[0]).then(swapTxValue => {
          if (swapTxValue?.info?.status) {
            if (swapTxValue.info.status == 0) {
              setsent(true)
              setTradeModalVisible(true);
              setSwapTx(swapTxValue.info);
            } else if (swapTxValue.info.status == 8) {
              setsent(true);
              setConfirmed(true);
              setTradeModalVisible(true);
              setSwapTx(swapTxValue.info);
            } else if (swapTxValue.info.status == 9) {
              setsent(true);
              setConfirmed(true);
              setRouting(true);
              setTradeModalVisible(true);
              setSwapTx(swapTxValue.info);
            } else if (swapTxValue.info.status == 10) {
              setsent(true);
              setConfirmed(true);
              setRouting(true);
              setSuccess(true);
              setTradeModalVisible(true);
              setSwapTx(swapTxValue.info);
            } else if (swapTxValue.info.status == 12) {
              const fromChainID = swapTxValue.info.fromChainID;
              const toChainID = swapTxValue.info.toChainID;
              const fromChainName = getConfigChainNamedById(Number(fromChainID));
              const toChainName = getConfigChainNamedById(Number(toChainID));
              const symbol = getAnySymbol(swapTxValue.info.pairid);
              helperToast.error(`bridge  ${fromChainName} to ${toChainName}  ${swapTx.formatvalue} ${symbol}  Wait24hours `);
            } else {
              setsent(false);
              setConfirmed(false);
              setRouting(false);
              setSuccess(false);
            }
          }
        });
      }
    }
  }, [active,chainId]);

  const isActive = false
  useEffect(() => {
    if (account) {
      let lib = null;
      // lib 上主网连接才设置
      getBalance(fromChainId, lib, account).then(fromAmountBalance => {
        if (currenToken.symbol == "ETH") {
          setFromChainAmount(fromAmountBalance);
          currenToken.balance = fromAmountBalance;
          setCurrenToken(currenToken);
        }
        tokenData[0].balance = fromAmountBalance;
        setTokenData(tokenData);
      }).catch(e=>console.log(e));

      getBalance(toChainId, null, account).then(toAmountBalance => {
        if (currenToken.symbol == "ETH") {
          setToChainAmount(toAmountBalance);
        }
        toTokenData[0].balance = toAmountBalance;
        setToTokenData(toTokenData);
      }).catch(e=>console.log(e));
      const btcAddress = getConfigCSAByName(fromToken, "BTC");
      getTokenBalance(fromChainId, btcAddress, lib, account).then(btcFromBalance => {
        tokenData[1].balance = btcFromBalance;
        setTokenData(tokenData);
        if (currenToken.symbol == "BTC") {
          setFromChainAmount(btcFromBalance);
          currenToken.balance = btcFromBalance;
          setCurrenToken(currenToken);
        }
      }).catch(e=>console.log(e));
      const btcToAddress = getConfigCSAByName(toToken, "BTC");

      getTokenBalance(toChainId, btcToAddress, lib, account).then(btcFromBalance => {
        if (currenToken.symbol == "BTC") {
          setToChainAmount(btcFromBalance);
        }
        toTokenData[1].balance = btcFromBalance;
        setToTokenData(toTokenData);
      }).catch(e=>console.log(e));

      getTokenApprove(fromChainId, lib, account, btcAddress).then(btcFromAllowanceBalance => {
        setFromApproveAmount(btcFromAllowanceBalance);
      }).catch(e=>console.log(e));

      getTokenApprove(toChainId, lib, account, btcToAddress).then(btcToAllowanceBalance => {
        setToApproveAmount(btcToAllowanceBalance);
      }).catch(e=>console.log(e));

      if (chainId != fromChainId) {
        switchNetwork(fromChainId, true).then(() => {
        }).catch((e) => {
          helperToast.error("switch Network failed");
        })
      }
    }
    getBridgeToken(getConfigChainsIdByName(fromToken)).then(toBridgeDatas => {
      setToBridgeData(toBridgeDatas.data)
    }).catch(e=>console.log(e));
    getBridgeToken(getConfigChainsIdByName(toToken)).then( toBridgeDatas=>{
      setFromBridgeData(toBridgeDatas.data)
    }).catch(e=>console.log(e));
    
  }, [account, setIsUpdate]);

  function checkIsApprove () {
    if (fromValue == 0) {
      return false;
    }
    if (currenToken.symbol == "ETH") {
      return false;
    } else if (currenToken.symbol == "BTC") {

      if (fromApproveAmount == 0) {
        return true;
      }
      return !fromApproveAmount?.mul(bigDec).gte(bigNumberify(floor(fromValue).toFixed(8) * decimals));
    }
    return true;
  }


  const switchToken = async () => {
    const fromChainIds = getConfigChainsIdByName(toToken);
    if (chainId != fromChainIds) {
      switchNetwork(fromChainIds, true).then(() => {
        
        setFromToken(toToken)
        setFormData(toData)
        setToData(formData)
        setToToken(fromToken)
        toTokenData.forEach(chainToken => {
          if (chainToken.symbol == currenToken.symbol) {
            setFromChainAmount(chainToken.balance);
            setCurrenToken(chainToken);
          }
        })
        tokenData.forEach(toChainToken => {
          if (toChainToken.symbol == currenToken.symbol) {
            setToChainAmount(toChainToken.balance);
          }
        })
        setToBridgeData(fromBridgeData);
        setFromBridgeData(toBridgeData);
        setTokenData([...toTokenData]);
        setToTokenData([...tokenData]);
        setToApproveAmount(fromApproveAmount);
        setFromApproveAmount(toApproveAmount);
      }).catch(e => {
        helperToast.error("switch Network failed");
      })
    }

  }
  // const getPrimaryText = () => {
  //   if (!active) {
  //     return t`Connect Wallet`;
  //   } else {
  //     return t`Bridge Token`;
  //   }
  // }
  const isPrimaryEnabled = () => {
    if (!active) {
      return true;
    }
  }
  useEffect(()=>{
    exchangeFromValue(fromValue);

  },[currenToken]);
  // const { data: toBridgeData } = useBridgeToken(getConfigChainsIdByName(fromToken));

  const selectToken = (token) => {
    setCurrenToken(token);
    setFromChainAmount(token.balance);
    toTokenData.forEach(toChainToken => {
      if (toChainToken.symbol == token.symbol) {
        setToChainAmount(toChainToken.balance)
      }
    })
    setTokenModalVisible(false);
  }
  function accMul (arg1, arg2) {
    let m = 0
    let s1 = arg1.toString()
    let s2 = arg2.toString()
    try {
      m += s1.split('.')[1] ? s1.split('.')[1].length : ''
    } catch (e) { }
    try {
      m += s2.split('.')[1] ? s2.split('.')[1].length : ''
    } catch (e) { }
    return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m)
  }

  function floor (value) {
    return Math.floor(value * 10000) / 10000;
  }


  function exchangeFromValue (fromvalues) {
    let value = Number(fromvalues)
    setFromValue(fromvalues)
    if (toBridgeData) {
      if (value > 0) {
        const fromBalances = expandDecimals(floor(value).toFixed(8) * decimals, currenToken.decimals);
        const prices = toBridgeData[currenToken.symbol]?.prices;
        const price = prices ? accMul(prices, decimals)  : 1 * decimals;
        console.log(prices,currenToken.symbol,accMul(Number(toBridgeData[currenToken.symbol].MinimumSwapFee) ,decimals),777);
        const minFee = expandDecimals(accMul(Number(toBridgeData[currenToken.symbol].MinimumSwapFee) , decimals), currenToken.decimals);
        const swapFeePm = bigNumberify(toBridgeData[currenToken.symbol].SwapFeeRatePerMillion / 100 * decimals)
        const bigdecs = bigDec.mul(bigDec);
        const swapFeePmAmount = fromBalances.mul(swapFeePm).div(bigDec);
        const pricsBig = bigNumberify(price);
        let tovalues;
        if (swapFeePmAmount.gte(minFee)) {
          let toBalances = fromBalances.mul(swapFeePm).div(bigDec);
          tovalues = formatAmount(fromBalances.sub(toBalances).mul(pricsBig).div(bigdecs), currenToken.decimals, 2, true);
        } else {
          tovalues = formatAmount(fromBalances.sub(minFee).mul(pricsBig).div(bigdecs), currenToken.decimals, 2, true);
        }
        setToValue(tovalues);

      } else if (value == 0) {
        setToValue("")
      }
    } 

  }
  function approveClick () {
    const btcAddress = getConfigCSAByName(fromToken, "BTC");
    setIsApprove(true)
    sendApprove(fromChainId, btcAddress, library, setIsApprove, setIsUpdate);
  }
  function TooltipData () {
    return (
      <div className="prompt-information">
        <Trans>Find a token by searching for it symbol</Trans>
      </div>
    )
  }
  const onSearchKeywordChange = (e) => {
    setSearchKeyword(e.target.value);
  };
  const onSelectToken = (token) => {
    // setIsModalVisible(false);
    // props.onSelectToken(token);
  };
  const _handleKeyDown = (e) => {
    if (e.key === "Enter" && tokenData.length > 0) {
      onSelectToken(tokenData[0]);
    }
  };
  const filteredTokens = tokenData.filter((item) => {
    return (
      item.symbol.toLowerCase().indexOf(searchKeyword.toLowerCase()) > -1
    );
  });

  function swapButtonText () {
    if (fromValue == 0) {
      return [t`Enter an amount`];
    }

    const fromBalances = expandDecimals(floor(fromValue).toFixed(8) * decimals, currenToken.decimals);
    const currentBalance = currenToken.balance.mul(bigDec);
    if (currentBalance.gte(fromBalances)) {
      return [t`Swap ${currenToken.symbol}`];
    }
    return [t`Insufficient ${currenToken.symbol} balance`];
  }
  function checkIsBalances () {
    if (fromValue == 0) {
      return true;
    }
    const fromBalances = expandDecimals(floor(fromValue).toFixed(8) * decimals, currenToken.decimals);
    const currentBalance = currenToken.balance.mul(bigDec);

    if (currentBalance.gte(fromBalances)) {
      if (isSendTx) {
        return true;
      }
      return false;
    } else if (checkIsApprove) {
      return true;
    }
    return true;
  }
  function sendSwapClick () {
    const amount = expandDecimals(floor(fromValue).toFixed(8) * decimals, currenToken.decimals).div(bigDec);
    setIsSendTx(true);
    const fromanyAddress = toBridgeData["ETH"].fromanytoken?.address;
    if (toBridgeData && fromanyAddress) {
      if (currenToken.symbol == "ETH") {
        sendAnySwapOutNative(fromanyAddress, account, fromChainId, toChainId, amount, library, setIsSendTx, setSwapTx, setTradeModalVisible, setBridgeSwapTx, bridgeSwapTx, setConfirmModalVisible);
      } else {
        const btcAddress = getConfigCSAByName(fromToken, "BTC");
        senAnySwapOutUnderlying(account, btcAddress, fromChainId, toChainId, amount, library, setIsSendTx, setSwapTx, setTradeModalVisible, setBridgeSwapTx, bridgeSwapTx, setConfirmModalVisible);
      }
    }
  }
  function getSwapFee () {
    let minFee = toBridgeData[currenToken.symbol]?.MinimumSwapFee;
    if (fromValue == 0) {
      return minFee;
    }
    const swapFeePm = toBridgeData[currenToken.symbol].SwapFeeRatePerMillion;
    if (minFee == 0) {
      return 0;
    }
    const fromAmountPmFees = accMul(fromValue, swapFeePm / 100);

    if (fromAmountPmFees > minFee) {
      return fromAmountPmFees;
    }
    return minFee;
  }
  function getChainIcon (chainId) {
    return chainId == 1 ? ethIcon : optimismIcon;
  }
  function getAnySymbol (pairid) {
    return pairid.search("ETH") != -1 ? "ETH" : pairid.search("BTC") != -1 ? "BTC" : "-";
  }
  useEffect(async () => {
    if (swapTx.txid.length > 10) {
      try {
        // 0	Pending
        // 3	ExceedLimit (LessThenMinAmount)
        // 8	Confirming
        // 9	Swapping
        // 10	Success
        // 12	BigAmount(Wait24hours)
        // 14	Failure
        // setSwapTxData({
        //   swapTxParam
        // });
        if (swapTx.status == 0) {
          setsent(true)
          getSwapTx(swapTx.txid).then(swapTxValue => {
            setSwapTx(swapTxValue.info);
          });
        } else if (swapTx.status == 8) {
          setsent(true);
          setConfirmed(true);
          getSwapTx(swapTx.txid).then(swapTxValue => {
            setSwapTx(swapTxValue.info);
          });
        } else if (swapTx.status == 9) {
          setsent(true);
          setConfirmed(true);
          setRouting(true);
          getSwapTx(swapTx.txid).then(swapTxValue => {
            setSwapTx(swapTxValue.info);
          });
        } else if (swapTx.status == 10) {
          setsent(true);
          setConfirmed(true);
          setRouting(true);
          setSuccess(true);
        } else if (swapTx.status == 12) {
          const fromChainID = swapTx.fromChainID;
          const toChainID = swapTx.toChainID;
          const fromChainName = getConfigChainNamedById(Number(fromChainID));
          const toChainName = getConfigChainNamedById(Number(toChainID));
          const symbol = getAnySymbol(swapTx.pairid);
          helperToast.error(`bridge  ${fromChainName} to ${toChainName}  ${swapTx.formatvalue} ${symbol}  Wait24hours `);
        } else {
          setsent(false);
          setConfirmed(false);
          setRouting(false);
          setSuccess(false);
        }

      } catch (e) {
        // helperToast.error()
      }
    }

  }, [setSwapTx]);
  const addToken = async (token) => {
    if (!window.ethereum) {
      helperToast.error("Could not add token to MetaMask");
      return;
    }

    try {
      // wasAdded is a boolean. Like any RPC method, an error may be thrown.
      await window.ethereum.request({
        method: "wallet_watchAsset",
        params: {
          type: "ERC20", // Initially only supports ERC20, but eventually more!
          options: {
            address: token.address, // The address that the token is at.
            symbol: token.symbol, // A ticker symbol or shorthand, up to 5 chars.
            decimals: token.info.decimals, // The number of decimals in the token
            image: token.info.imageUrl, // A string url of the token logo
          },
        },
      });
    } catch (error) {
      helperToast.error("Could not add token to MetaMask");
    }
  };

  function sendClickAddToken (chainId) {
    if (swapTx && chainId == fromChainId && getAnySymbol(swapTx.pairid) == "BTC") {
      const btcAddress = getConfigCSAByName(chainId);
      const token = {
        address: btcAddress, // The address that the token is at.
        symbol: "BTC", // A ticker symbol or shorthand, up to 5 chars.
        decimals: 8, // The number of decimals in the token
      }
      addToken(token);
    }
  }
  function showSwapClick () {
    swapTx.fromChainID = fromChainId;
    swapTx.toChainID = toChainId;
    swapTx.pairid = currenToken.symbol;
    // "formatswapvalue": "0.009879",
    // "formatvalue": "0.01",
    swapTx.formatfee = getSwapFee();
    swapTx.formatswapvalue = (Number(fromValue) - Number(swapTx.formatfee)).toFixed(6);

    swapTx.formatvalue = fromValue;
    setConfirmModalVisible(true);
  }
  return (
    <SEO title={getPageTitle("Bridge")}>
      <div className="default-container Bridge page-layout">
        <div className="section-title-block">
          <div className="section-title-content">
            <div className="Page-title">
              <Trans>Bridge</Trans>
            </div>
          </div>
        </div>
        <div className={cx({ "Bridge-content": active, "Unconnected-Bridge-content": !active })}>
          <div className="Bridge-box">
            {!active && <div className="Bridg-Mask"></div>}
            <div className="Bridge-box-title">
              <Trans>Bridge your tokens</Trans>
            </div>
            <div className="Bridge-box-divider"></div>
            <div className="Bridge-box-content">
              <div className="switch-currency">
                <div className="switch-currency-box">
                  <span>
                    <Trans>From Chain</Trans>
                  </span>
                  <img src={fromImage} alt="" className="switch-currency-icon" />
                </div>
                <div className="switch-currency-btn" onClick={switchToken}>
                  <img src={SwitchOver} alt="" className="switch" />
                </div>
                <div className="switch-currency-box">
                  <span>
                    <Trans>To Chain</Trans>
                  </span>
                  <img src={toImage} alt="" className="switch-currency-icon" />
                </div>
              </div>
              <div className="select-platform-box" >
                <div className="select-platform">
                  <SelectDropdown
                    data={formData}
                    currentPlatform={fromToken}
                    setcurrentPlatform={setFromToken}
                  />
                </div>
                <div className="select-platform">
                  <SelectDropdown
                    data={toData}
                    currentPlatform={toToken}
                    setcurrentPlatform={setToToken}
                  />
                </div>
              </div>
              <div className="select-tokens-box">
                <div className="select-tokens" onClick={() => { setTokenModalVisible(true) }}>
                  {/* <SelectDropdown data={PlatformData} /> */}
                  <div className="current-tokens" >
                    {currenToken.symbol}
                  </div>
                  <img src={Arrow} alt="" className="arrow" />
                </div>
                <Modal
                  className="Select-tokens-modal Connect-wallet-modal"
                  isVisible={TokenModalVisible}
                  setIsVisible={setTokenModalVisible}
                  label={t`Select a token`}
                  promptIcon={TooltipData}
                >
                  <input
                    type="text"
                    placeholder={t`Search token name`}
                    className="Select-tokens-input"
                    value={searchKeyword}
                    onChange={(e) => onSearchKeywordChange(e)}
                    onKeyDown={_handleKeyDown}
                    autoFocus
                  />
                  <div className="Select-tokens-title">
                    <span>
                      <Trans>Token name</Trans>
                    </span>
                    <img src={DownloadIcon} alt="" />
                  </div>
                  {filteredTokens.map((token, index) => {
                    const toImage = importImage(`ic_${token.symbol.toLowerCase()}_24.png`);
                    return (
                      <div className="Select-tokensn-row" key={index} onClick={() => { selectToken(token) }}>
                        <div className="Token-symbol">
                          <img src={toImage} alt="" className="Token-Img" />
                          <div className="Token-text">{token.symbol}</div>
                          <img src={IncreaseIcon} alt="" />
                        </div>
                        {/* <div className="Token-text">No Fee</div> */}
                        <div className="Token-Value">{formatAmount(token.balance, token.decimals, 3, true)}</div>
                      </div>
                    )
                  })}
                </Modal>
                <div className="select-currency-input">
                  <input
                    type="number"
                    min="0"
                    placeholder="0.0"
                    className="currency-input"
                    value={fromValue}
                    onChange={(e) => exchangeFromValue(e.target.value)}
                  />
                  <div className="Prompt-text"> {toValue == 0 ? "~" : `$${toValue}`}</div>
                </div>
              </div>

              <div className="balance-ethereum">
                <Trans>Balance on {fromToken}:</Trans>
                {formatAmount(fromChainAmount, 18, 3, true)} {currenToken.symbol}
              </div>
              <div className="balance-bsc">
                <Trans>Balance on {toToken}:</Trans>
                {formatAmount(toChainAmount, 18, 3, true)} {currenToken.symbol}
              </div>
              <div className="enter-referral-code">
                {!active && <button className="App-cta ConnectWallet-button" type="submit" onClick={connectWallet} disabled={!isPrimaryEnabled()}>
                  <Trans>Connect Wallet</Trans>
                </button>}
                {active && <div className="button-box">
                  {checkIsApprove() &&
                    <button className="App-cta Approve-button" type="submit" disabled={isApprove} onClick={() => { approveClick() }} >
                      <Trans>Approve {currenToken.symbol}</Trans>
                    </button>
                  }

                  <button className="Swap-button" type="submit" disabled={checkIsBalances()} onClick={() => { showSwapClick() }} >
                    {swapButtonText()}
                  </button>
                  {active && <Modal
                    className="Select-tokens-modal Connect-wallet-modal Transaction-details-modal"
                    isVisible={TradeModalVisible}
                    setIsVisible={setTradeModalVisible}
                    label={t`Transaction Details`}
                  >
                    <div className="Transaction-container">
                      <div className="Transaction-card">
                        <div className="Transaction-card-title">From</div>
                        <div className="Transaction-card-row">
                          <div className="card-row-left">
                            <img src={getChainIcon(Number(swapTx.fromChainID))} alt="" className="card-row-left-icon" />
                            <span>{getConfigChainNamedById(swapTx.fromChainID)}</span>
                          </div>
                          <div className="card-row-right">
                            <span>-{swapTx.formatvalue} {getAnySymbol(swapTx.pairid)} </span>
                            <img src={metaMaskIcon} alt="" className="metaMaskIcon" onClick={() => sendClickAddToken(Number(swapTx.fromChainID))} />
                          </div>
                        </div>
                        <div className="Transaction-card-row">
                          <div className="lable">Tx hash:</div>
                          <div className="hash">
                            <a href={configScanPath[(Number(swapTx.fromChainID))] + "/tx/" + swapTx.txid} target="_blank" className="adress">
                              {swapTx.txid.slice(0, 18)}....
                            </a>
                            <img src={CopyIcon} alt="" className="copyIcon" onClick={() => {
                              copyToClipboard(swapTx.txid);
                              helperToast.success(t`Address copied to your clipboard`);
                            }} />
                          </div>
                        </div>
                        <div className="Transaction-card-row">
                          <div className="lable">From:</div>
                          <div className="hash">
                            <a href={configScanPath[(Number(swapTx.fromChainID))] + "/address/" + account} target="_blank" className="adress">
                              {account.slice(0, 8)}...{account.slice(-6)}
                            </a>
                            <img src={CopyIcon} alt="" className="copyIcon" onClick={() => {
                              copyToClipboard(account);
                              helperToast.success(t`Address copied to your clipboard`);
                            }} />
                          </div>
                        </div>
                      </div>
                      <div className="Transaction-card">
                        <div className="Transaction-card-title">To</div>
                        <div className="Transaction-card-row">
                          <div className="card-row-left">
                            <img src={getChainIcon(Number(swapTx.toChainID))} alt="" className="card-row-left-icon" />
                            <span>{getConfigChainNamedById(swapTx.toChainID)}</span>
                          </div>
                          <div className="card-row-right">
                            <span>+{swapTx.formatswapvalue} {getAnySymbol(swapTx.pairid)}</span>
                            <img src={metaMaskIcon} alt="" className="metaMaskIcon" onClick={() => sendClickAddToken(Number(swapTx.toChainID))} />
                          </div>
                        </div>
                        <div className="Transaction-card-row">
                          <div className="lable">Tx hash:</div>
                          <div className="hash">
                            <a href={configScanPath[(Number(swapTx.toChainID))] + "/tx/" + swapTx.swaptx} target="_blank" className="adress">{swapTx.swaptx ? swapTx.swaptx.slice(0, 16) : "-"}....</a>
                            <img src={CopyIcon} alt="" className="copyIcon" onClick={() => {
                              copyToClipboard(swapTx.swaptx ? swapTx.swaptx : "-");
                              helperToast.success(t`Address copied to your clipboard`);
                            }} />
                          </div>
                        </div>
                        <div className="Transaction-card-row">
                          <div className="lable">From:</div>
                          <div className="hash">
                            <a href={configScanPath[(Number(swapTx.toChainID))] + "/address/" + account} target="_blank" className="adress">
                              {account.slice(0, 8)}...{account.slice(-6)}
                            </a>
                            <img src={CopyIcon} alt="" className="copyIcon" onClick={() => {
                              copyToClipboard(account);
                              helperToast.success(t`Address copied to your clipboard`);
                            }} />
                          </div>
                        </div>
                      </div>
                      <div className="Transaction-steps">
                        <ul className="steps">
                          <li>
                            <span className={cx("number", { isActive: sent })}>
                              {sent ? <img src={ActiveIcon} alt="" className="activeIcon" /> : "1"}
                            </span>
                            <div>
                              {!sent && <img src={LoadingIcon} alt="" className="loading" />}
                              <span>Sent</span>
                            </div>
                          </li>
                          <li>
                            <span className={cx("number", { isActive: Confirmed })}>
                              {Confirmed ? <img src={ActiveIcon} alt="" className="activeIcon" /> : "2"}
                            </span>
                            <div>
                              {sent && !Confirmed && <img src={LoadingIcon} alt="" className="loading" />}
                              <span>Confirmed</span>
                            </div>
                          </li>
                          <li>
                            <span className={cx("number", { isActive: Routing })}>
                              {Routing ? <img src={ActiveIcon} alt="" className="activeIcon" /> : "3"}
                            </span>
                            <div>
                              {Confirmed && !Routing && <img src={LoadingIcon} alt="" className="loading" />}
                              <span>Routing</span>
                            </div>
                          </li>
                          <li>
                            <span className={cx("number", { isActive: Success })}>
                              {Success ? <img src={ActiveIcon} alt="" className="activeIcon" /> : "4"}
                            </span>
                            <div>
                              {Routing && !Success && <img src={LoadingIcon} alt="" className="loading" />}
                              <span>Success</span>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div className="Transaction-time">
                        <span>Time used:</span>
                        <span>{swapTx.time}s</span>
                      </div>
                    </div>
                  </Modal>
                  }
                  {active && <Modal
                    className="Select-tokens-modal Connect-wallet-modal Transaction-details-modal"
                    isVisible={confirmModalVisible}
                    setIsVisible={setConfirmModalVisible}
                    label={t`Cross-chain Router`}
                  >
                    <div className="Transaction-container">
                      <div className="Transaction-card">
                        <div className="Transaction-card-title">From</div>
                        <div className="Transaction-card-row">
                          <div className="card-row-left">
                            <img src={getChainIcon(Number(swapTx.fromChainID))} alt="" className="card-row-left-icon" />
                            <span>{getConfigChainNamedById(swapTx.fromChainID)}</span>
                          </div>
                          <div className="card-row-right">
                            <span>-{swapTx.formatvalue} {getAnySymbol(swapTx.pairid)} </span>
                            <img src={metaMaskIcon} alt="" className="metaMaskIcon" onClick={() => sendClickAddToken(Number(swapTx.fromChainID))} />
                          </div>
                        </div>
                        <div className="Transaction-card-row">
                          <div className="lable">From:</div>
                          <div className="hash">
                            <a href={configScanPath[(Number(swapTx.fromChainID))] + "/address/" + account} target="_blank" className="adress">
                              {account.slice(0, 8)}...{account.slice(-6)}
                            </a>
                            <img src={CopyIcon} alt="" className="copyIcon" onClick={() => {
                              copyToClipboard(account);
                              helperToast.success(t`Address copied to your clipboard`);
                            }} />
                          </div>
                        </div>
                      </div>
                      <div className="Transaction-card">
                        <div className="Transaction-card-title">To</div>
                        <div className="Transaction-card-row">
                          <div className="card-row-left">
                            <img src={getChainIcon(Number(swapTx.toChainID))} alt="" className="card-row-left-icon" />
                            <span>{getConfigChainNamedById(swapTx.toChainID)}</span>
                          </div>
                          <div className="card-row-right">
                            <span>+{swapTx.formatswapvalue} {getAnySymbol(swapTx.pairid)}</span>
                            <img src={metaMaskIcon} alt="" className="metaMaskIcon" onClick={() => sendClickAddToken(Number(swapTx.toChainID))} />
                          </div>
                        </div>
                        <div className="Transaction-card-row">
                          <div className="lable">From:</div>
                          <div className="hash">
                            <a href={configScanPath[(Number(swapTx.toChainID))] + "/address/" + account} target="_blank" className="adress">
                              {account.slice(0, 8)}...{account.slice(-6)}
                            </a>
                            <img src={CopyIcon} alt="" className="copyIcon" onClick={() => {
                              copyToClipboard(account);
                              helperToast.success(t`Address copied to your clipboard`);
                            }} />
                          </div>
                        </div>
                      </div>

                      <div className="card-label">
                        <div className="message">
                          <span><Trans>Crosschain Fee:</Trans></span>
                          <TooltipIcon
                            position="right"
                            handleClassName="plain"
                            renderContent={
                              () => {
                                return (
                                  <>
                                    <div>
                                      {/* <Trans>
                                费用为 {getSwapFee()}{currenToken.symbol}，最低费用为 {toBridgeData[currenToken.symbol].MinimumSwapFee}  {currenToken.symbol}，最高费用为 {toBridgeData[currenToken.symbol].MaximumSwapFee} {currenToken.symbol},超过最低收费则按照 {toBridgeData[currenToken.symbol].SwapFeeRatePerMillion}%。
                              </Trans> */}
                                      <Trans>
                                        The fee is {getSwapFee()}{currenToken.symbol}, the minimum fee is {toBridgeData[currenToken.symbol].MinimumSwapFee} {currenToken.symbol}, the maximum fee is {toBridgeData[currenToken.symbol].MaximumSwapFee} {currenToken.symbol} , If the minimum fee is exceeded, it will be charged according to {toBridgeData[currenToken.symbol].SwapFeeRatePerMillion}%.
                                      </Trans>
                                    </div><br />
                                    <div>
                                      <Trans>The fee is charged by Multichain,AVT no additional fee</Trans>
                                    </div>
                                  </>
                                )
                              }
                            }
                          />

                        </div>

                        <span className="value">{getSwapFee()} {currenToken.symbol}</span>
                      </div>
                      <div className="card-label">
                        <span><Trans>Estimated Time</Trans></span>
                        <span><Trans>10-30 min</Trans></span>
                      </div>
                    </div>

                    <button className="Confirm-button" type="submit" disabled={isSendTx} onClick={() => { sendSwapClick() }} >
                      <Trans>Confirmed </Trans>
                      {isSendTx && <img src={LoadingIcon} alt="" className="loading" />}
                    </button>
                  </Modal>
                  }
                </div>}
              </div>
              {/* {!active && <div className="text"><Trans>Powered Multichain Network</Trans></div>} */}
            </div>
          </div>

          {active && <div className="Bridge-card">
            <div className="Bridge-card-title">
              <Trans>More info</Trans>
            </div>
            <div className="Bridge-box-divider"></div>
            <div className="Bridge-card-content">
              <div className="Bridge-card-row">
                <span className={cx("label", {
                  positive: isMax,
                  negative: !isMax,

                })}>
                  <Trans>Max Bridge Amount</Trans>
                </span>
                <span className={cx("value", {
                  positive: isMax,
                  negative: !isMax,
                })}>{toBridgeData[currenToken.symbol].MaximumSwap} {currenToken.symbol}</span>
              </div>
              <div className="Bridge-card-row">
                <span className={cx("label", {
                  positive: !isMin,
                  negative: isMin,

                })}>
                  <Trans>Min Bridge Amount</Trans>
                </span>
                <span className={cx("value", {
                  positive: !isMin,
                  negative: isMin,
                })}>{toBridgeData[currenToken.symbol].MinimumSwap} {currenToken.symbol}</span>
              </div>
              <div className="Bridge-card-row">
                <div className="label">
                  <div>
                    <Trans>Minimum Fee</Trans>
                  </div>
                  <TooltipIcon
                    position="left-bottom"
                    handleClassName="plain"
                    renderContent={
                      () => {
                        return (
                          <>
                            <div>
                              {/* <Trans>
                                费用为 {getSwapFee()}{currenToken.symbol}，最低费用为 {toBridgeData[currenToken.symbol].MinimumSwapFee}  {currenToken.symbol}，最高费用为 {toBridgeData[currenToken.symbol].MaximumSwapFee} {currenToken.symbol},超过最低收费则按照 {toBridgeData[currenToken.symbol].SwapFeeRatePerMillion}%。
                              </Trans> */}
                              <Trans>
                                The fee is {getSwapFee()}{currenToken.symbol}, the minimum fee is {toBridgeData[currenToken.symbol].MinimumSwapFee} {currenToken.symbol}, the maximum fee is {toBridgeData[currenToken.symbol].MaximumSwapFee} {currenToken.symbol} , If the minimum fee is exceeded, it will be charged according to {toBridgeData[currenToken.symbol].SwapFeeRatePerMillion}%.
                              </Trans>
                            </div><br />
                            <div>
                              <Trans>The fee is charged by Multichain,AVT no additional fee</Trans>
                            </div>
                          </>
                        )
                      }
                    }
                  />
                </div>
                <span className="value">{toBridgeData[currenToken.symbol].MinimumSwapFee} {currenToken.symbol}</span>
              </div>
              <div className="Bridge-card-tips">
                <Trans>Estimated Time of Crosschain Arrival is 10-30 min</Trans>
              </div>
              <div className="Bridge-card-tips">
                <Trans>
                  Amounts greater than {parseFloat(toBridgeData[currenToken.symbol].MaximumSwap / 1000).toFixed(5)} {currenToken.symbol} could take up to 12 hours
                </Trans>
              </div>
            </div>
          </div>}
        </div >
        <Footer />
      </div >
    </SEO >
  )
}
export default Bridge